document.addEventListener('DOMContentLoaded', function () {

  /* ---------- HEADER SCROLL STATE ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    });
  }

  /* ---------- PROMO BANNER ---------- */
  var promoBanner = document.querySelector('[data-promo-banner]');
  var promoClose = document.querySelector('[data-promo-close]');
  if (promoBanner && promoClose) {
    if (sessionStorage.getItem('bvm_promo_dismissed') === '1') {
      promoBanner.classList.add('is-hidden');
    }
    promoClose.addEventListener('click', function () {
      promoBanner.classList.add('is-hidden');
      sessionStorage.setItem('bvm_promo_dismissed', '1');
    });
  }

  /* ---------- CAROUSEL ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var slides = carousel.querySelectorAll('.carousel-slide');
    var dots = carousel.querySelectorAll('[data-carousel-dot]');
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');
    var index = 0;
    var total = slides.length;
    var autoplayTimer;

    function goTo(i) {
      index = (i + total) % total;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('active', di === index); });
    }

    function startAutoplay() {
      clearInterval(autoplayTimer);
      if (total > 1) autoplayTimer = setInterval(function () { goTo(index + 1); }, 5500);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); startAutoplay(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.carouselDot, 10));
        startAutoplay();
      });
    });

    var touchStartX = 0;
    carousel.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    carousel.addEventListener('touchend', function (e) {
      var delta = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 40) {
        goTo(delta < 0 ? index + 1 : index - 1);
        startAutoplay();
      }
    }, { passive: true });

    startAutoplay();
  });

  /* ---------- MOBILE MENU ---------- */
  var menuBtn = document.querySelector('[data-mobile-menu-toggle]');
  if (menuBtn && header) {
    menuBtn.addEventListener('click', function () {
      var isOpen = header.classList.toggle('menu-open');
      menuBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    document.querySelectorAll('[data-mobile-menu] a').forEach(function (link) {
      link.addEventListener('click', function () {
        header.classList.remove('menu-open');
        menuBtn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- SCROLL REVEAL ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) e.target.classList.add('in-view');
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.reveal, .trust-item').forEach(function (el) { io.observe(el); });

  /* ---------- FILTER TABS (catalogue) ---------- */
  document.querySelectorAll('[data-filter-tabs] .tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tabs = btn.closest('[data-filter-tabs]');
      tabs.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var filter = btn.dataset.filter;
      var grid = tabs.parentElement.querySelector('[data-filter-grid]');
      if (!grid) return;
      grid.querySelectorAll('.product-card').forEach(function (card) {
        card.classList.toggle('hidden', filter !== 'all' && card.dataset.cat !== filter);
      });
    });
  });

  /* ---------- TOAST ---------- */
  var toastTimer;
  window.showToast = function (msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2200);
  };

  /* ---------- CART COUNT UPDATE ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.add('bump');
      setTimeout(function () { el.classList.remove('bump'); }, 250);
    });
  }

  /* ---------- ADD TO CART (AJAX, progressive enhancement) ---------- */
  document.querySelectorAll('.product-form, .product-form-inline').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.add-btn, button[type="submit"]');
      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          if (btn) {
            btn.classList.add('added');
            setTimeout(function () { btn.classList.remove('added'); }, 1200);
          }
          showToast('Ajouté au panier ✓');
        })
        .catch(function (err) {
          showToast((err && err.description) || 'Rupture de stock ou erreur');
        });
    });
  });

  /* ---------- QUANTITY STEPPER (page produit) ---------- */
  var qtyInput = document.getElementById('qtyInput');
  if (qtyInput) {
    var minus = document.querySelector('[data-qty-minus]');
    var plus = document.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
    });
  }

  /* ---------- GALLERY THUMBNAILS (page produit) ---------- */
  var mainImg = document.getElementById('mainProductImage');
  document.querySelectorAll('.gallery-thumbs button').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.gallery-thumbs button').forEach(function (b) { b.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg) mainImg.src = thumb.dataset.full;
    });
  });

  /* ---------- VARIANT PICKER (page produit) ---------- */
  var variantsScript = document.getElementById('productVariantsData');
  var variantForm = document.getElementById('productForm');
  if (variantsScript && variantForm) {
    var variants = JSON.parse(variantsScript.textContent);
    var optionGroups = variantForm.querySelectorAll('[data-option-index]');
    var selectedIdInput = document.getElementById('selectedVariantId');
    var stockStatus = document.getElementById('stockStatus');
    var submitBtn = variantForm.querySelector('button[type="submit"]');

    function currentSelection() {
      var sel = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.pill-option.active');
        sel.push(active ? active.dataset.value : null);
      });
      return sel;
    }

    function findVariant(selection) {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return selection.every(function (val, i) { return val === null || opts[i] === val; });
      });
    }

    function sizedUrl(url) {
      if (!url) return url;
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=900';
    }

    function syncVariant() {
      var selection = currentSelection();
      var match = findVariant(selection);
      if (match) {
        selectedIdInput.value = match.id;
        if (stockStatus) stockStatus.textContent = match.available ? 'En stock' : 'Rupture';
        if (submitBtn) submitBtn.disabled = !match.available;

        if (match.featured_image && match.featured_image.src) {
          if (mainImg) mainImg.src = sizedUrl(match.featured_image.src);
          document.querySelectorAll('.gallery-thumbs button').forEach(function (btn) {
            btn.classList.toggle('active', btn.dataset.mediaId === String(match.featured_image.id));
          });
        }
      }
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('.pill-option').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.pill-option').forEach(function (p) { p.classList.remove('active'); });
          pill.classList.add('active');
          syncVariant();
        });
      });
    });

    syncVariant();
  }
});
